import { addons } from '@storybook/manager-api';
import  iteaMDBTheme from './iteaMDBTheme';

addons.setConfig({
  theme: iteaMDBTheme,
});
